import React, { useState, useEffect } from 'react';
import ShowNotification from '../../../components/react-notifications/react-notifications';
import { NotificationMessageType } from "../../../utils/configuration";

var query = null;

export default function ListPlanning(props) {
    const { planningType, openLayerController } = props;
    const [listPlanning, setListPlanning] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (planningType) {
            setListPlanning(planningType);
        }
    }, [planningType])

    const handleClickRow = (item) => {
        try {
            if (openLayerController && openLayerController.zoomToAndShowFeatureTooltip) {
                openLayerController.zoomToAndShowFeatureTooltip(item.coord, {
                    planningId: item.id,
                    tooltipValue: item.name,
                    address: item.address,
                    area: item.area,
                    percentage: item.percentage,
                    investor: item.investor,
                    note: item.note,
                    title: item.title,
                    content: item.content,
                }, 15);
                return;
            }
            ShowNotification(
                'Bản đồ chưa sẵn sàng.',
                NotificationMessageType.Warning
            );
        } catch (e) {
            ShowNotification(
                'Không thể zoom tới khu công nghiệp.',
                NotificationMessageType.Warning
            );
        }
    }

    const onchangeSearch = (inputValue) => {
        if (query) {
            clearTimeout(query);
        }

        if (inputValue.length > 0) {
            setLoading(true);
            query = setTimeout(() => {
                // return locationSvc.getLookupAutoComplete(params).then(({ content }) => {
                if (inputValue) {
                    const getListPlanning = async () => {
                        let results = [];
                        if (planningType) {
                            planningType.map(item => {
                                if (item.name.toLowerCase().includes(inputValue.toLowerCase())) {
                                    results.push({ ...item, value: item.id, label: item.name });
                                }
                            })
                            setListPlanning(results);
                        }
                    }
                    getListPlanning();
                }
                setLoading(false);
            }, 800);
        } else {
            setLoading(false);
            setListPlanning(planningType);
        }
    }

    return (
        <div className='position-relative'>
            <div className='position-sticky' style={{ top: '0', zIndex: '10', backgroundColor: '#fff' }}>
                <div className="title-container p-2">
                    Tổng hợp khu công nghiệp
                </div>
                <div className='search_input px-2'>
                    <input
                        className="search_input_coord"
                        type="text"
                        placeholder="Nhập tên khu công nghiệp"
                        onChange={e => onchangeSearch(e.target.value)}
                    // onKeyDown={pressKey}
                    />
                </div>
            </div>
            <div className="planning-table-wrapper">
                <table className="planning-table">
                    <thead>
                        <tr>
                            <th>Tên</th>
                            <th>Địa chỉ</th>
                            <th>{'Diện tích (ha)'}</th>
                            <th>{'Tỷ lệ lấp đầy (%)'}</th>
                            <th>Chủ đầu tư</th>
                            <th>Ghi chú</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={6}>Đang tải...</td>
                            </tr>
                        ) : (
                            listPlanning && listPlanning.length > 0 ?
                                listPlanning.map((item, index) => (
                                    <tr key={index} style={{ cursor: 'pointer' }} onClick={() => handleClickRow(item)}>
                                        <td>{item.name}</td>
                                        <td>{item?.address || '-'}</td>
                                        <td>{item?.area || '-'}</td>
                                        <td>{item?.percentage || '-'}</td>
                                        <td>{item?.investor || '-'}</td>
                                        <td>{item?.note || '-'}</td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan={6}>Không có dữ liệu</td>
                                    </tr>
                                )
                        )}
                    </tbody>
                </table>
            </div>

        </div>
    )
}